export type BrowserWorkspace = "staff" | "customer";

export function browserWorkspace(): BrowserWorkspace {
  return typeof window !== "undefined" && /^\/agent(?:\/|$)/.test(window.location.pathname) ? "staff" : "customer";
}

export function requestWorkspace(path: string, headers?: Headers): BrowserWorkspace {
  const explicit = headers?.get("X-Support-Workspace");
  if (explicit === "staff" || explicit === "customer") return explicit;
  const pathname = new URL(path, "https://support.invalid").pathname.replace(/^\/api\/v1/, "");
  if (/^\/(?:agent|admin)(?:\/|$)/.test(pathname) || pathname.startsWith("/auth/staff/")
    || pathname === "/push/preferences" || /\/attachments\/[^/]+\/scan\/retry$/.test(pathname)) return "staff";
  if (/^\/tickets(?:\/|$)/.test(pathname) || pathname.startsWith("/auth/customer/")) return "customer";
  return browserWorkspace();
}

// Links cannot carry custom request headers. Scope only local attachment links;
// leave external/signed URLs untouched.
export function attachmentWorkspaceUrl(value: string, workspace = browserWorkspace()): string {
  const url = new URL(value, window.location.origin);
  if (url.origin !== window.location.origin || !url.pathname.startsWith("/api/v1/attachments/")) return value;
  url.searchParams.set("workspace", workspace);
  return url.toString();
}
